import { useContext, useMemo } from 'react';
import { getExtendedLogger } from './helpers';

import { Context } from './Provider';

function useExtendedLogger(extension: string) {
  const context = useContext(Context);
  return useMemo(() => getExtendedLogger(extension, context.log), [extension, context]);
}

export default useExtendedLogger;
